<ion-menu side="start" swipeGesture="false" [contentId]="contentId" menuId="custom" class="my-custom-menu">
  <ion-header class="ion-no-border">
    <my-side-menu-header [user]="user" [business]="business"></my-side-menu-header>
  </ion-header>

  <ion-content class="my-background-secondary side-menu-content" scrollY="true">
    <ion-list class="side-menu-list ion-margin-top">
      <ion-item button lines="full" (click)="onClickGoToPage('home')">
        <fa-icon slot="start" [icon]="['fas', 'bell']" [fixedWidth]="true"></fa-icon>
        <ion-label>Pedidos</ion-label>
      </ion-item>
      <ion-accordion-group>
        <ion-accordion value="admin">
          <ion-item slot="header">
            <fa-icon [icon]="['fas', 'list']" [fixedWidth]="true"></fa-icon>
            <ion-label>Catálogo</ion-label>
            <!-- <my-new [count]="2"></my-new> -->
          </ion-item>
          <ion-list slot="content" class="ion-padding-start">
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('products')">
              <fa-icon slot="start" [icon]="['fas', 'list-alt']" [fixedWidth]="true"></fa-icon>
              <ion-label>Productos</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('templates')">
              <fa-icon slot="start" [icon]="['fas', 'puzzle-piece']" [fixedWidth]="true"></fa-icon>
              <ion-label>Opciones y adicionales</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('categories')">
              <fa-icon slot="start" [icon]="['fas', 'line-columns']" [fixedWidth]="true"></fa-icon>
              <ion-label>Categorías</ion-label>
            </ion-item>
          </ion-list>
        </ion-accordion>
      </ion-accordion-group>
      <ion-accordion-group>
        <ion-accordion value="admin">
          <ion-item slot="header">
            <fa-icon [icon]="['fas', 'cogs']" [fixedWidth]="true"></fa-icon>
            <ion-label>Administrar</ion-label>
            <!-- <my-new [count]="1"></my-new> -->
          </ion-item>
          <ion-list slot="content" class="ion-padding-start">
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('hours-operation')">
              <fa-icon slot="start" [icon]="['fas', 'clock']" [fixedWidth]="true"></fa-icon>
              <ion-label>Horarios</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('referrals')">
              <fa-icon slot="start" [icon]="['fas', 'share-all']" [fixedWidth]="true"></fa-icon>
              <ion-label>Link de Referidos</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('image-upload')">
              <fa-icon slot="start" [icon]="['fas', 'image']" [fixedWidth]="true"></fa-icon>
              <ion-label>Cargar Imágenes</ion-label>
            </ion-item>
          </ion-list>
        </ion-accordion>
      </ion-accordion-group>
      <ion-accordion-group>
        <ion-accordion value="admin">
          <ion-item slot="header">
            <fa-icon [icon]="['fas', 'file-chart-line']" [fixedWidth]="true"></fa-icon>
            <ion-label>Reportes</ion-label>
            <!-- <my-new [count]="1"></my-new> -->
          </ion-item>
          <ion-list slot="content" class="ion-padding-start">
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('reports/sales')">
              <fa-icon slot="start" [icon]="['fas', 'chart-line']" [fixedWidth]="true"></fa-icon>
              <ion-label>Reporte de Ventas</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('reports/orders')">
              <fa-icon slot="start" [icon]="['fas', 'eye']" [fixedWidth]="true"></fa-icon>
              <ion-label>Detalle de Ventas</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('reports/complaints')">
              <fa-icon slot="start" [icon]="['fas', 'triangle-exclamation']" [fixedWidth]="true"></fa-icon>
              <ion-label>Detalle de Reclamos</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('reports/clients')">
              <fa-icon slot="start" [icon]="['fas', 'user']" [fixedWidth]="true"></fa-icon>
              <ion-label>Clientes</ion-label>
            </ion-item>
            <!-- <ion-item button lines="full" detail="true" (click)="onClickGoToPage('reports/sales-x-products')">
              <fa-icon slot="start" [icon]="['fas', 'chart-bar']" [fixedWidth]="true"></fa-icon>
              <ion-label>Ventas x Productos</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('reports/sales-x-months')">
              <fa-icon slot="start" [icon]="['fas', 'chart-bar']" [fixedWidth]="true"></fa-icon>
              <ion-label>Ventas x Mes</ion-label>
            </ion-item> -->
          </ion-list>
        </ion-accordion>
      </ion-accordion-group>
      <ion-accordion-group>
        <ion-accordion value="admin">
          <ion-item slot="header">
            <fa-icon [icon]="['fas', 'bullseye-arrow']" [fixedWidth]="true"></fa-icon>
            <ion-label>Campañas</ion-label>
            <!-- <my-new [count]="1"></my-new> -->
          </ion-item>
          <ion-list slot="content" class="ion-padding-start">
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('campaigns/new')">
              <fa-icon slot="start" [icon]="['fas', 'plus-circle']" [fixedWidth]="true"></fa-icon>
              <ion-label>Nueva Campaña</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('campaigns/view')">
              <fa-icon slot="start" [icon]="['fas', 'eye']" [fixedWidth]="true"></fa-icon>
              <ion-label>Ver Campañas</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('codes')">
              <fa-icon slot="start" [icon]="['fas', 'gift-card']" [fixedWidth]="true"></fa-icon>
              <ion-label>Generación de Códigos</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('giveaways')">
              <fa-icon slot="start" [icon]="['fas', 'gift-card']" [fixedWidth]="true"></fa-icon>
              <ion-label>Sorteos</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('automatic-optin')">
              <fa-icon slot="start" [icon]="['fas', 'users-gear']" [fixedWidth]="true"></fa-icon>
              <ion-label>Promociones Gratis Automáticas</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('social-networks')">
              <fa-icon slot="start" [icon]="['fas', 'globe']" [fixedWidth]="true"></fa-icon>
              <ion-label>Medir Campañas en Redes Sociales</ion-label>
            </ion-item>
          </ion-list>
        </ion-accordion>
      </ion-accordion-group>
      <ion-accordion-group [disabled]="false">
        <ion-accordion value="admin">
          <ion-item slot="header">
            <fa-icon [icon]="['fas', 'moped']" [fixedWidth]="true"></fa-icon>
            <ion-label>Cadetería</ion-label>
            <!-- <my-new [count]="5"></my-new> -->
          </ion-item>
          <ion-list slot="content" class="ion-padding-start">
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('ondemand/riders')">
              <fa-icon slot="start" [icon]="['fas', 'person-carry-box']" [fixedWidth]="true"></fa-icon>
              <ion-label>Cadetes</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('ondemand/riders-location')">
              <fa-icon slot="start" [icon]="['fas', 'map']" [fixedWidth]="true"></fa-icon>
              <ion-label>Ubicación de cadetes</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('ondemand/groups')">
              <fa-icon slot="start" [icon]="['fas', 'hourglass-clock']" [fixedWidth]="true"></fa-icon>
              <ion-label>Turnos</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('ondemand/tasksbyrider')">
              <fa-icon slot="start" [icon]="['fas', 'box-circle-check']" [fixedWidth]="true"></fa-icon>
              <ion-label>Entregas por Cadete</ion-label>
            </ion-item>
            <ion-item button lines="full" detail="true" (click)="onClickGoToPage('ondemand/tasksbybusiness')">
              <fa-icon slot="start" [icon]="['fas', 'box-circle-check']" [fixedWidth]="true"></fa-icon>
              <ion-label>Entregas por Negocio</ion-label>
            </ion-item>
          </ion-list>
        </ion-accordion>
      </ion-accordion-group>
      <ion-item button lines="full" (click)="onClickGoToPage('dzones')">
        <fa-icon slot="start" [icon]="['fas', 'map']" [fixedWidth]="true"></fa-icon>
        <ion-label>Zonas</ion-label>
      </ion-item>
      <ion-item button lines="full" (click)="onClickGoToPage('config')">
        <fa-icon slot="start" [icon]="['fas', 'cogs']" [fixedWidth]="true"></fa-icon>
        <ion-label>Config</ion-label>
      </ion-item>
      <ion-item button lines="full" *ngIf="user?.roles.sysAdmin" (click)="onClickGoToPage('sysadmin')">
        <fa-icon slot="start" [icon]="['fas', 'screwdriver-wrench']" [fixedWidth]="true"></fa-icon>
        <ion-label>Sys Admin</ion-label>
      </ion-item>
      <ion-item *ngIf="!user" button lines="full" (click)="onClickEnter()">
        <fa-icon slot="start" [icon]="['fas', 'sign-in-alt']" [fixedWidth]="true"></fa-icon>
        <ion-label>Iniciar Sesión</ion-label>
      </ion-item>
      <ion-item *ngIf="user" button lines="full" (click)="onClickExit()">
        <fa-icon slot="start" class="icon-logout" [icon]="['fas', 'sign-out-alt']" [fixedWidth]="true"></fa-icon>
        <ion-label>Cerrar Sesión</ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-menu>